import {
  DataTableFilter,
  ExpensesExpensableFilter,
  FilterType,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'
import { trackFilters } from './utils'

const documentTypeFilter = ({
  expensesContext,
}: BaseFilterProps): DataTableFilter<ExpensesExpensableFilter> => {
  const options = [
    {
      label: i18n.t('expenses_v2.list.filters.receipt'),
      value: 'receipt',
    },
    {
      label: i18n.t('expenses_v2.list.filters.invoice'),
      value: 'invoice',
    },
    {
      label: i18n.t('expenses_v2.list.filters.other'),
      value: 'other',
    },
  ]

  return {
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    onUpdateValue: () => {
      trackFilters('document_type', expensesContext)
    },
    identifier: 'expensesList.documentTypeFilter',
    path: 'documentType',
    title: i18n.t('expenses_v2.list.filters.label_document_type'),
  }
}

export default documentTypeFilter
